import dayjs from "dayjs";
export const validateActionItemName = (value: any) => {
  if (!value.trim()) {
    return "This field cannot be empty";
  }
  if (value.length < 8) {
    return "Must be at least 8 characters";
  }
  if (/^[ _]/.test(value)) {
    return "Cannot start with a space or underscore (_).";
  }
  if (/^\d/.test(value)) {
    return "Cannot start with a number.";
  }
  if (/[ _]$/.test(value)) {
    return "Cannot end with a space or underscore (_).";
  }
  if (/[^A-Za-z0-9_ -]/.test(value)) {
    return "Only letters, numbers, single spaces, underscores (_), and hyphens (-) are allowed.";
  }
  if (/^-|-$/.test(value)) {
    return "Cannot start or end with a hyphen (-).";
  }
  if (/\s{2,}/.test(value)) {
    return "Double spaces are not allowed.";
  }

  return "";
};

export const isEmpty = (value: any) => {
  if (!value) {
    return "This field cannot be empty";
  }
  return "";
};
export const validateText = (value: any) => {
  if (!value.trim()) {
    return "This field cannot be empty";
  }
  if (value.length < 4) {
    return "Must be at least 4 characters.";
  }
  return "";
};

export const validateDateFormat = (date: any) => {
  const formattedDate = dayjs(date).format("DD/MM/YYYY");
  const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([1-9][0-9]{3})$/;

  if (!date || date === "" || !dayjs(date).isValid()) {
    return "This field cannot be empty";
  }

  if (!dateRegex.test(formattedDate)) {
    return "Invalid date format. Use DD/MM/YY with a valid day, month, and a two-digit year.";
  }
  return "";
};
